import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import _ from "lodash";
import { Pagination } from "..";
import { Loading } from "../../components/common";



const AdminUnderApprovalDatasets = () => {

    const sorting = {
        AToZ: "a_z_alphabetically",
        ZToA: "z_a_alphabetically",
    }

    const filteringInitialState = {
        sorting: "",
        paging: 1
    }

    const [searchResults, setSearchResults] = useState(null);

    const [displayResults, setDisplayResults] = useState(null);  //searchresult->resourresult to show

    const [selectedSortingValue, setSelectedSortingValue] = useState(filteringInitialState.sorting);
    const [selectedPage, setSelectedPage] = useState(filteringInitialState.paging);

    const [formData, setFormData] = useState({
        pageSize: 30,
        itemsCount: 0,
        totalPages: 0
    });


    const deleteDataset = async (resource_item) => {
        if (window.confirm('Delete the dataset?')) {
            const token = sessionStorage.getItem('tokens')
            try {
                const res = await api.delete("/rehab", {
                    credentials: 'include',
                    withCredentials: true,
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                    data: {
                        "rehabId": resource_item.id
                    }
                }
                );
                window.confirm("Dataset Deleted. Please refresh the page to view.")
            } catch (e) {
                console.log(e);
                if (e.response.data.code === 401 && e.response.data.message.includes('Token expired')) {
                    const token = sessionStorage.getItem('tokens')
                    const refreshTokens = sessionStorage.getItem('refreshTokens')

                    const res = await api.post('/auth/refresh-tokens', { "refreshToken": refreshTokens }, {
                        credentials: 'include',
                        withCredentials: true,
                        headers: {
                            "Authorization": `Bearer ${token}`,
                        },
                    },
                    );
                    sessionStorage.setItem('tokens', res.data.access.token)
                    sessionStorage.setItem('refreshTokens', res.data.refresh.token)

                    try {
                        const token = sessionStorage.getItem('tokens')
                        const res = await api.delete("/rehab", {
                            credentials: 'include',
                            withCredentials: true,
                            headers: {
                                "Authorization": `Bearer ${token}`,
                            },
                            data: {
                                "rehabId": resource_item.id
                            }
                        }
                        );
                        window.confirm("Dataset Deleted. Please refresh the page to view.")
                    } catch (err) {
                        console.log("errors:", err)
                        window.confirm("Failed to Delete Dataset.")
                    }
                } else {
                    window.confirm("Error: " + e.response.data.message);
                }
            }
        }
    }


    const approveDataset = async (resource_item) => {
        const token = sessionStorage.getItem('tokens')
        try {
            const res = await api.put("/rehab/approve", { "rehabId": resource_item.id }, {
                credentials: 'include',
                withCredentials: true,
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            window.confirm("Dataset Approved. Please refresh the page to view.")
        } catch (e) {
            console.log(e);
            if (e.response.data.code === 401 && e.response.data.message.includes('Token expired')) {
                const token = sessionStorage.getItem('tokens')
                const refreshTokens = sessionStorage.getItem('refreshTokens')

                const res = await api.post('/auth/refresh-tokens', { "refreshToken": refreshTokens }, {
                    credentials: 'include',
                    withCredentials: true,
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                },
                );
                sessionStorage.setItem('tokens', res.data.access.token)
                sessionStorage.setItem('refreshTokens', res.data.refresh.token)

                try {
                    const token = sessionStorage.getItem('tokens')

                    const res = await api.put("/rehab/approve", { "rehabId": resource_item.id }, {
                        credentials: 'include',
                        withCredentials: true,
                        headers: {
                            "Authorization": `Bearer ${token}`,
                        },
                    }
                    );
                    window.confirm("Dataset Approved. Please refresh the page to view.")
                } catch (err) {
                    console.log("errors:", err)
                    window.confirm("Failed to Approve the Dataset.")
                }
            } else {
                window.confirm("Error: " + e.response.data.message);
            }
        }
    }

    const getUnderApprovalDataset = async (pageSize, page) => {
        const token = sessionStorage.getItem('tokens')
        try {
            const res = await api.get(`/rehab/under-approval?limit=${pageSize}&page=${page}`,
                {
                    credentials: 'include',
                    withCredentials: true,
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    }
                }
            );
            combineAllResults(res.data);
        } catch (e) {
            console.log(e);
            if (e.response.data.code === 401 && e.response.data.message.includes('Token expired')) {
                const token = sessionStorage.getItem('tokens')
                const refreshTokens = sessionStorage.getItem('refreshTokens')

                const res = await api.post('/auth/refresh-tokens', { "refreshToken": refreshTokens }, {
                    credentials: 'include',
                    withCredentials: true,
                    headers: {
                        "Authorization": `Bearer ${token}`,
                    },
                },
                );
                sessionStorage.setItem('tokens', res.data.access.token)
                sessionStorage.setItem('refreshTokens', res.data.refresh.token)

                try {
                    const token = sessionStorage.getItem('tokens')
                    const res = await api.get(`/rehab/under-approval?limit=${pageSize}&page=${page}`,
                        {
                            credentials: 'include',
                            withCredentials: true,
                            headers: {
                                "Authorization": `Bearer ${token}`,
                            }
                        }
                    );
                    combineAllResults(res.data);
                } catch (e) {
                    console.log("errors:", e)
                }
            } else {
                window.confirm("Error: " + e.response.data.message);
            }
        }
    }

    useEffect(() => {
        getUnderApprovalDataset(formData.pageSize, selectedPage);
    }, []);

    const onPageChange = (page) => {
        setSelectedPage(page);
        setSelectedSortingValue(filteringInitialState.sorting);
        getUnderApprovalDataset(formData.pageSize, page);

    };


    const combineAllResults = (datasets) => {
        setFormData({ ...formData, totalPages: (datasets.totalPages ? datasets.totalPages : 1) });
        setDisplayResults(datasets.results);
        setSearchResults(datasets.results);
        setFormData({ ...formData, itemsCount: (datasets.totalResults ? datasets.totalResults : 0) });


    }

    const getName = (resourceItem) => {
        if (resourceItem.category === "dataset") {
            return resourceItem.basicInformation.datasetName;
        }
        else {
            return "";
        }
    }
    const filterResults = (param) => {
        if (param.sorting) {
            setSelectedSortingValue(param.sorting);
        }
        if (param.paging) {
            setSelectedPage(param.paging);
        }
        let sortParam = param.sorting || selectedSortingValue;
        let pageParam = param.paging || selectedPage;

        // 1. do filtering based on searchResult
        // 2. do sorting based on result 1
        // 3. filtering results on specific page on paging
        // 4. set filtering results to displayResults
        let newResult = [...searchResults]
        if (sortParam === sorting.AToZ) {
            newResult.sort((a, b) => {
                let name1 = getName(a);
                let name2 = getName(b);
                return name1.localeCompare(name2);
            })
        }
        else if (sortParam === sorting.ZToA) {
            newResult.sort((a, b) => {
                let name1 = getName(a);
                let name2 = getName(b);
                return name2.localeCompare(name1);
            })
        }
        setDisplayResults(newResult);
    }

    if (_.isNull(displayResults)) {

        return (
            <div className="background-container pt-5">
                <Loading />
            </div>
        );
    }

    return (
        <div className="background-container">
            <div className="mx-5 py-5">
                <div className="row">
                    <div>
                        <h4 className="text-muted text-left p-1">Sorting</h4>
                        <div>
                            <a className={"sorting-link " + (selectedSortingValue === 'a_z_alphabetically' ? 'active-sorting-link' : '')} onClick={() => filterResults({ sorting: "a_z_alphabetically" })}>Alphabetically A-Z</a>
                        </div>
                        <div>
                            <a className={"sorting-link " + (selectedSortingValue === 'z_a_alphabetically' ? 'active-sorting-link' : '')} onClick={() => filterResults({ sorting: "z_a_alphabetically" })}>Alphabetically Z-A</a>
                        </div>
                    </div>

                    <div className="search-area">
                        <p className="text-dark text-left text-muted ">
                            {formData.itemsCount !== 0 ? `${formData.itemsCount}` : "0"}
                            {"\u00a0"} resources found.
                        </p>

                        {!!displayResults ? (
                            <div className='resource-grid'>
                                {displayResults.map(resource => {
                                    return (
                                        <div className="resource-item">
                                            <div className="rehab_card">
                                                <h4> {resource.basicInformation.datasetName} </h4>
                                                <div className="tag">
                                                    <i>Dataset</i>
                                                </div>
                                                <div className="keyword">
                                                    <i>Keywords:</i> {resource.basicInformation.keyTerms.join(", ")}
                                                </div>

                                                <Link to={`/rehab/${resource.id}`} className="trailer-btn">
                                                    view details
                                                </Link>
                                                <div className='two-buttons-layout'>
                                                    <Link to={`/admin_edit_dataset/${resource.id}`} className="edit-button">
                                                        Edit
                                                    </Link>
                                                    <button onClick={() => deleteDataset(resource)}>Delete</button>
                                                    <button onClick={() => approveDataset(resource)}>Approve</button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                                }</div>
                        ) : (
                            <h1 className="text-white">No Resources</h1>
                        )}
                        <br />

                        <Pagination
                            itemsCount={formData.itemsCount}
                            pageSize={formData.pageSize}
                            onPageChange={onPageChange}
                            currentPage={selectedPage}
                        />
                    </div>
                </div>
            </div>
        </div>

    );
};


export default AdminUnderApprovalDatasets;
